import React, { ReactElement, useEffect, useState, useRef } from 'react';
import className from 'classnames/bind';
import { connect } from 'react-redux';
import styles from './index.scss';
import { showModal, hideModal } from '../../../../actions/shared/modal';
import PhotoGridShimmer from '../../../shimmers/photosGrid.shimmer';
import PhotoGridShimmerDesktop from '../../../shimmers/photosGridDesktop.shimmer';
import { replaceWithJioCDN } from '../../../../utils/imageHandling';
import { gtmEventPush, segmentEventPush } from '../../../../modules/ga/GTMdatalayer';

const cx = className.bind(styles);

const fetchPhotosForGrid = productReviews => {
  let photoArr = [];
  productReviews &&
    productReviews.length > 0 &&
    productReviews.map(el => {
      let obj = el;
      el.imageMap?.thumbnail.map(el2 => {
        obj.img = el2;
        photoArr.push(obj);
      });
    });
  return photoArr;
};

const CustomerPhotoGridModal = ({
  viewPhotoReviews,
  app,
  showModal,
  hideModal,
  showHalfCardSingleClick,
  loading,
  fetchData,
  pageNumber,
  pageSize,
  isFleek = false,
  productDetails = {}
}: {}): ReactElement => {
  const allReviews = viewPhotoReviews;
  const allPhotoReviews = fetchPhotosForGrid(allReviews);
  const [apiCalled, setApiCalled] = useState(false);
  const targetRef = useRef(null);

  const onClickImage = obj => {
    const singleReview = viewPhotoReviews.filter(el => {
      return el.reviewId === obj.reviewId;
    });
    const idx = singleReview[0]?.imageMap?.thumbnail.findIndex(el1 => {
      return el1.imageId === obj?.img?.imageId;
    });

    const { productId = '', productName = '', productBrick = '' } = productDetails || {};

    gtmEventPush({
      event: 'reviews_rating_interactions',
      event_category: 'reviews_rating_interactions',
      event_action: 'review photos - viewed',
      event_label: obj.reviewId,
      ...(productId.length > 0 && { product_id: productId }),
      ...(productName.length > 0 && { product_name: productName }),
      ...(productBrick.length > 0 && { product_brick: productBrick }),
      pageType: 'PDP',
      store_type: 'ajio'
    });
    // Semgment Push event
    segmentEventPush({
      event: 'Review Widget Interaction',
      event_category: 'reviews_rating_interactions',
      event_action: 'review photos - viewed',
      event_label: obj.reviewId,
      products:[{
          ...(productId.length > 0 && { product_id: productId }),
          ...(productName.length > 0 && { product_name: productName }),
          ...(productBrick.length > 0 && { product_brick: productBrick }),
          product_brand: '',
          product_list_price: '',
          product_mrp: '',
          product_offer_price: '',
          product_rating: '',
          product_segment: '',
          product_vertical: '',
          screen_name: ''
      }],
      // pageType: 'PDP',
      store_type: 'ajio'
    });
    
    if (app === 'DESKTOP') {
      showModal('reviews-single-photo', {
        state: {
          reviewsCollection: viewPhotoReviews,
          reviewData: singleReview[0],
          clickIndex: idx,
          arrowEnabled: true,
          fromCustomerGridModal: true
        }
      });
      // hideModal("reviews-customer-photos-grid");
    } else {
      showModal('reviews-single-photo', {
        state: {
          reviewsCollection: viewPhotoReviews,
          reviewData: singleReview[0],
          clickIndex: idx,
          arrowEnabled: true,
          fromCustomerGridModal: true
        }
      });
      showHalfCardSingleClick();
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        const target = entries[0];
        if (target.isIntersecting && !apiCalled) {
          callApi();
          setApiCalled(true);
        } else if (!target.isIntersecting && apiCalled) {
          setApiCalled(false);
        }
      },
      { threshold: 0.9 }
    );

    observer.observe(targetRef.current);

    // cleanup function to disconnect the observer
    return () => {
      observer.disconnect();
    };
  }, [targetRef, apiCalled]);

  useEffect(() =>{

    const { productId = '', productName = '', productBrick = '' } = productDetails || {};

    // Semgment Push event - Review Widget Viewed
    segmentEventPush({
      event: 'Review Widget Viewed',
      event_category: 'reviews_rating_interactions',
      event_action: 'review photos - viewed',
      //event_label: obj.reviewId,
      products:[{
          ...(productId.length > 0 && { product_id: productId }),
          ...(productName.length > 0 && { product_name: productName }),
          ...(productBrick.length > 0 && { product_brick: productBrick }),         
          product_brand: '',
          product_list_price: '',
          product_mrp: '',
          product_offer_price: '',
          product_quality_subrating: '',
          product_rating: '',
          product_segment: '',
          product_vertical: '',
       
      }],
      avg_ratings_of_reviews: '',
      count_of_people_found_useful: '',
      no_of_ratings_collected: '',
      review_count: '',
      review_with_images: '',
      size_and_fit_subrating: '',
      value_for_money_subrating: '',
      screen_name: 'PDP Screen',
      // pageType: 'PDP',
      store_type: 'ajio'
    });

  }, []);

  const callApi = () => {
    if (allPhotoReviews && allPhotoReviews.length > 0 && allPhotoReviews.length % pageSize === 0)
      fetchData(pageNumber + 1);
  };

  return (
    <>
      <div
        className={cx(
          app === 'DESKTOP' ? 'customer-photos-grid-modal-web' : 'customer-photos-grid-modal-msite'
        )}
      >
        {app !== 'DESKTOP' && (
          <div className={cx('customer-photos-grid-header', isFleek && 'fleek-heading')}>
            <p>Photo Reviews</p>
          </div>
        )}
        <div
          ref={targetRef}
          className={cx(
            app === 'DESKTOP'
              ? 'customer-photos-grid-container-web'
              : 'customer-photos-grid-container-msite'
          )}
        >
          {allPhotoReviews.length > 0 &&
            allPhotoReviews.map((el, index) => {
              const imgUrl = el.img?.imageUrl || '';
              return (
                <div
                  key={index}
                  className={cx(
                    app === 'DESKTOP'
                      ? 'customer-photos-grid-items-web'
                      : 'customer-photos-grid-items-msite'
                  )}
                  onClick={e => {
                    onClickImage(el);
                  }}
                >
                  <img
                    className={cx(
                      app === 'DESKTOP' ? 'customer-photos-img-web' : 'customer-photos-img-msite'
                    )}
                    src={`${replaceWithJioCDN(imgUrl)}`}
                    alt="Customer review image"
                  />
                </div>
              );
            })}
        </div>
        {loading && app !== 'DESKTOP' && <PhotoGridShimmer isFleek={isFleek} />}
        {loading && app === 'DESKTOP' && <PhotoGridShimmerDesktop />}
      </div>
    </>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    showModal: (name, config) => dispatch(showModal(name, config)),
    hideModal: name => {
      dispatch(hideModal(name));
    }
  };
};
const mapStateToProps = state => {
  const modals = state ? state.modals : {};
  const ratingModal = modals?.['order-details-review-content'] || {};
  const displayReviewDetailsCard = Object.entries(ratingModal).length !== 0;
  return {
    displayReviewDetailsCard
  };
};
const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(CustomerPhotoGridModal);
